import { AxiosResponse } from "axios";
import { BaseService } from "./BaseService";
import apiClient from "../http/apiClient";
import _ from "lodash";
import encryptionHelper from "../helpers/encryptionHelper";
import { DBFile } from "../models/db/DBFile";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';


export class FileService extends BaseService {
    constructor(props?: any) {
        super(props);
    }

    async downloadAndZipFiles(id: string, files: { path: string, name: string }[]): Promise<void> {
        const zip = new JSZip();

        const fetchedFiles = await Promise.all(files.map(async (file) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const response: AxiosResponse = await apiClient.get(`${process.env.REACT_APP_BASE_URL}/file/${encryptionHelper.encryptBase64(file.path)}`, {
                        responseType: 'blob'
                    });
                    resolve([file.name, response.data]);
                } catch (error) {
                    console.error(`Failed to download file: ${file.path}`, error);
                }
            });
        }));

        const applicationFile = await this.downloadApplication(id);
        
        _.concat(fetchedFiles, [applicationFile]).forEach(([name, blob]: any) => {
            zip.file(name, blob);
        });

        zip.generateAsync({ type: 'blob' })
            .then((content) => {
                saveAs(content, 'files.zip');
            })
            .catch((error) => {
                console.error('Failed to generate zip file', error);
            });
    }

    async downloadApplication(id: string): Promise<[name: string, data: any]> {
        const response: AxiosResponse = await apiClient.get(`${process.env.REACT_APP_BASE_URL}/application/${id}/pdf`, {
            responseType: 'blob'
        });
        return [`application-${id}.pdf`, response.data];
    }
}